import React from 'react';
import bag from '../../images/bag.png';
import horizontal from '../../images/horizontal.png';
import chart from '../../images/chart.png';
import vertical from '../../images/vertical.png';
import menu from '../../images/menu.png';
import fact_check_new from '../../images/fact_check_new.png';


const Whatit = (props) => {
    return (
        <>
        <section className="intro_about_section section_space pt-0">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 text-center">
                        <span class="sub_heading">WHAT IT DOES</span>
                        <br/>
                        <br/>
                        <div class="heading_block">
                            <h2 class="heading_text heading_top">Our Ai Driven SEO <br/> for Saas</h2>
                        </div>
                    </div>

                    <div className="col-lg-5">
                        <div class="col-md-12">
                            <img src={bag} alt="bag" className='img-fluid'/>
                            <h3 className='whatit_head'>Entity & Topical <br/> Authority</h3>
                            <p class="heading_description text-dark mb-0">We build your knowledge graph—entity pages, expert bios, reviews/PR, and schema—so both Google and LLMs recognize your authority.</p>
                        </div>
                        <img src={horizontal} alt="horizontal" className='img-fluid'/>
                        <div class="col-md-12">
                            <img src={chart} alt="chart" className='img-fluid'/>
                            <h3 className='whatit_head'>Content <br/> Optimization</h3>
                            <p class="heading_description text-dark mb-0">Scale integration, use-case, industry, features, and alternatives vs competitor pages with consistent UX, metadata, and internal links.</p>
                        </div>
                    </div>
                    <div className="col-lg-2 text-center">
                        <img src={vertical} alt="vertical" className='img-fluid hide_in_phone'/>
                        <img src={horizontal} alt="horizontal" className='img-fluid hide_in_web'/>
                    </div>
                    <div className="col-lg-5">
                        <div class="col-md-12">
                            <img src={menu} alt="bag" className='img-fluid'/>
                            <h3 className='whatit_head'>Entity & Topical <br/> Authority</h3>
                            <p class="heading_description text-dark mb-0">Structure facts, FAQs, citations, and comparisons to ensure LLMs like ChatGPT, Perplexity, and Gemini confidently reference your product, with pages optimized for crisp product info, pricing clarity, and reliable quoting.</p>
                        </div>
                        <img src={horizontal} alt="horizontal" className='img-fluid'/>
                        <div class="col-md-12">
                            <img src={fact_check_new} alt="chart" className='img-fluid'/>
                            <h3 className='whatit_head'>Content <br/> Optimization</h3>
                            <p class="heading_description text-dark mb-0">Auditing, identifying, and fixing  the technical SEO issues on the website and content making it more aligned with the LLM which will help in LLM citations. </p>
                        </div>

                    </div>

                    <div class="col-md-12 text-center">
                            <button className="read_more btn btn-secondary">Contact Now</button>
                    </div>
                    


                </div>
            </div>
        </section>
        </>
    )
}

export default Whatit;